export function secondsToMiliseconds(seconds: number) {
  return seconds * 1000;
}
